// src/components/AnswerButtons.js
import React from "react";
import "./style.css";

const GoldenButton = ({ content, onClick, disabled, containerStyle, buttonStyle }) => {
  return (
    <div className={`button-start-test ${disabled}`} style={containerStyle}>
      <button onClick={onClick} style={buttonStyle}>
        {content}
      </button>
    </div>
  );
};

export default GoldenButton;
